<template>
  <div button-accept="false" button-cancel="false" :active.sync="isActive">
    <div class="mb-4 flex items-center">
      <vs-button @click="isActive = false" color="dark" type="filled" icon-pack="feather" icon="icon-arrow-left"> Back </vs-button>
    </div>
    <form>
      <div class="vx-row">
        <h3 class="text-xl w-full font-bold my-5">Basic Details</h3>
        <!-- Full Name -->
        <div class="vx-col w-1/2 mb-3">
          <vs-input
            icon-pack="feather"
            class="w-full"
            v-model="form.fullName"
            :label="'Full Name *'"
            v-validate="'required|exclude_special_char'"
            placeholder="Eg. CTO / CEO at XYZ"
            name="Full Name"
            id="Full Name"
            data-vv-as="Full Name"
            :disabled="!isEditable"
          />
          <span class="text-danger text-sm" v-show="errors.has('Full Name')">{{ errors.first('Full Name') }}</span>
        </div>

        <!-- Description -->
        <div class="vx-col w-1/2 mb-2">
          <label class="vs-input--label" for="description">Description</label>
          <vs-textarea
            placeholder="Any notes? Example - taxation details"
            class="w-full mb-0"
            id="description"
            v-validate="'exclude_special_char'"
            name="description"
            v-model="form.description"
            data-vv-as="Description"
            :rows="3"
          />
          <span class="text-danger text-sm" v-show="errors.has('description')">{{ errors.first('description') }}</span>
        </div>

        <vs-divider></vs-divider>

        <h3 class="text-xl w-full font-bold my-5">Member Photo</h3>

        <div class="vx-col w-full cursor-pointer">
          <label class="vs-input--label block"> Image </label>
          <input
            type="file"
            class="border p-2 rounded w-full"
            name="image"
            ref="files"
            accept=".jpg, .png , .jpeg"
            @change="handleFileUpload($event, 'member_photo')"
            style="border: 1px solid rgba(0, 0, 0, 0.2)"
            data-vv-as="Image"
          />
          <span class="text-danger text-sm" v-show="errors.has('image')">{{ errors.first('image') }}</span>
          <div class="mt-5">
            <div class="relative" v-if="image.preview_image">
              <div class="mt-5 overflow-hidden">
                <img height="164px" width="164px" :src="image.preview_image" alt="Image Preview" class="object-fit" />
              </div>
            </div>
          </div>
        </div>
        <vs-divider></vs-divider>

        <!-- Social Media Links Section -->
        <div class="vx-col w-full mb-4">
          <h3 class="text-xl font-bold my-10">Social Media Links</h3>
          <div class="vx-row mt-4">
            <!-- Facebook -->
            <div class="vx-col w-1/3 mb-8">
              <vs-input
                class="w-full"
                v-validate="'url'"
                v-model="form.social_media.facebook"
                label="Facebook"
                placeholder="https://www.facebook.com/YourPage"
                name="Facebook"
                id="Facebook"
                :disabled="!isEditable"
              />
              <span class="text-danger text-sm" v-show="errors.has('Facebook')">{{ errors.first('Facebook') }}</span>
            </div>
            <!-- Instagram -->
            <div class="vx-col w-1/3 mb-8">
              <vs-input
                class="w-full"
                v-validate="'url'"
                v-model="form.social_media.instagram"
                label="Instagram"
                placeholder="https://www.instagram.com/YourProfile"
                name="Instagram"
                id="Instagram"
                :disabled="!isEditable"
              />
              <span class="text-danger text-sm" v-show="errors.has('Instagram')">{{ errors.first('Instagram') }}</span>
            </div>
            <!-- Twitter -->
            <div class="vx-col w-1/3 mb-8">
              <vs-input
                class="w-full"
                v-validate="'url'"
                v-model="form.social_media.twitter"
                label="Twitter"
                placeholder="https://www.twitter.com/YourProfile"
                name="Twitter"
                id="Twitter"
                :disabled="!isEditable"
              />
              <span class="text-danger text-sm" v-show="errors.has('Twitter')">{{ errors.first('Twitter') }}</span>
            </div>
            <!-- Snapchat -->
            <div class="vx-col w-1/3 mb-8">
              <vs-input
                class="w-full"
                v-validate="'url'"
                v-model="form.social_media.snapchat"
                label="Snapchat"
                placeholder="https://www.snapchat.com/YourProfile"
                name="Snapchat"
                id="Snapchat"
                :disabled="!isEditable"
              />
              <span class="text-danger text-sm" v-show="errors.has('Snapchat')">{{ errors.first('Snapchat') }}</span>
            </div>
            <!-- TikTok -->
            <div class="vx-col w-1/3 mb-8">
              <vs-input
                class="w-full"
                v-validate="'url'"
                v-model="form.social_media.tiktok"
                label="TikTok"
                placeholder="https://www.tiktok.com/@YourProfile"
                name="TikTok"
                id="TikTok"
                :disabled="!isEditable"
              />
              <span class="text-danger text-sm" v-show="errors.has('TikTok')">{{ errors.first('TikTok') }}</span>
            </div>
            <!-- LinkedIn -->
            <div class="vx-col w-1/3 mb-8">
              <vs-input
                class="w-full"
                v-validate="'url'"
                v-model="form.social_media.linkedin"
                label="LinkedIn"
                placeholder="https://www.linkedin.com/in/YourProfile"
                name="LinkedIn"
                id="LinkedIn"
                :disabled="!isEditable"
              />
              <span class="text-danger text-sm" v-show="errors.has('LinkedIn')">{{ errors.first('LinkedIn') }}</span>
            </div>
            <!-- YouTube -->
            <div class="vx-col w-1/3 mb-8">
              <vs-input
                class="w-full"
                v-validate="'url'"
                v-model="form.social_media.youtube"
                label="YouTube"
                placeholder="https://www.youtube.com/c/YourChannel"
                name="YouTube"
                id="YouTube"
                :disabled="!isEditable"
              />
              <span class="text-danger text-sm" v-show="errors.has('YouTube')">{{ errors.first('YouTube') }}</span>
            </div>
          </div>
        </div>

        <!-- Save & Cancel Buttons -->
        <div class="vx-row mt-6">
          <div>
            <vs-button class="mr-2 vs-con-loading__container" id="create-member" @click="save_changes" v-if="isEditable">Save Changes</vs-button>
            <vs-button color="danger" @click="navigateList" class="text-white-500"> Cancel </vs-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Select2 from '@/components/custom/form-elements/Select2.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  /** Component Name */
  name: 'AddUpdateMember',

  /** Props */
  props: {
    selectedRecordId: String,
    module_name: String,
    action_name: String,
    showModal: Boolean,
    clonedData: Object // NEW PROP FOR CLONED DATA
  },

  components: {
    Select2
  },

  /** Data */
  data() {
    return {
      form: {
        fullName: null,
        member_photo: null,
        description: '',
        organization: this.$route.params.id,
        social_media: {
          facebook: null,
          instagram: null,
          twitter: null,
          snapchat: null,
          tiktok: null,
          linkedin: null,
          youtube: null
        }
      },
      image: {
        preview_image: ''
      },
      isEditing: !!this.selectedRecordId
    }
  },

  /** Computed Properties */
  computed: {
    ...mapState('organization', ['createLoading']),
    ...mapGetters('auth', ['checkPermissionSlug']),
    isEditable() {
      return this.checkPermissionSlug('organization_member_edit')
    },
    validateForm() {
      return !this.errors.any()
    },
    isActive: {
      get() {
        return this.showModal
      },
      set(val) {
        this.$emit('update:showModal', val)
      }
    }
  },

  /** Lifecycle Hooks */
  async created() {
    if (this.clonedData) {
      this.form = { ...this.clonedData }
    } else if (this.selectedRecordId) {
      try {
        const res = await this.$store.dispatch('organization/memberShow', this.selectedRecordId)
        const data = res.data.data

        /* Initialize form with fetched data */
        this.form.description = data.description || ''
        this.form.fullName = data.fullName || ''
        this.image.preview_image = data.member_photo ? data.member_photo : null
        this.form.social_media = {
          facebook: null,
          instagram: null,
          twitter: null,
          snapchat: null,
          tiktok: null,
          linkedin: null,
          youtube: null,
          ...data.social_media // Overwrite with existing data from API
        }
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.message || 'Failed to load member details.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    }
  },

  /** Methods */
  methods: {
    ...mapActions('organization', {
      create: 'createMember',
      update: 'updateMember'
    }),

    navigateList() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Cancel`,
        text: `Are you sure you want to cancel?`,
        accept: () => {
          this.isActive = false
        },
        acceptText: 'Yes',
        cancelText: 'No'
      })
    },
    handleFileUpload(e, fileType) {
      const file = e.target.files[0]

      // Check if a file is selected
      if (!file) {
        this.$vs.notify({
          title: 'Error',
          text: 'No file selected',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }

      // Validate file type
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png']
      if (!validTypes.includes(file.type)) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please select a valid image file (JPG, JPEG, PNG)',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }

      // Create preview URL
      const blob = URL.createObjectURL(file)

      // Store the file in form data and show preview
      this.form.member_photo = file
      this.image.preview_image = blob
    },

    /**
     * Save Changes Handler
     */
    async save_changes() {
      // Validate the entire form
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the errors first.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }

      const data = new FormData()

      for (const key in this.form) {
        if (key === 'social_media') {
          for (const smKey in this.form.social_media) {
            if (this.form.social_media[smKey]) {
              data.append(`social_media[${smKey}]`, this.form.social_media[smKey])
            }
          }
        } else if (this.form[key] !== null) {
          data.append(key, this.form[key])
        }
      }

      if (this.isEditing) {
        try {
          // Update existing Member
          const response = await this.update({
            id: this.selectedRecordId,
            data
          })

          // Close modal and notify success
          this.isActive = false
          this.$emit('update-data', true)
          this.$vs.notify({
            title: 'Success',
            text: response.message || 'Member updated successfully.',
            iconPack: 'feather',
            icon: 'icon-check',
            position: 'top-center',
            time: 5000,
            color: 'success'
          })
        } catch (error) {
          // Notify error
          this.$vs.notify({
            title: 'Error',
            text: error.message || 'An error occurred while updating.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
        }
      } else {
        try {
          // Create new Member
          const response = await this.create(data)

          // Close modal and notify success
          this.isActive = false
          this.$emit('update-data', true)
          this.$vs.notify({
            title: 'Success',
            text: response.message || 'Member created successfully.',
            iconPack: 'feather',
            icon: 'icon-check',
            position: 'top-center',
            time: 5000,
            color: 'success'
          })
        } catch (error) {
          // Notify error
          this.$vs.notify({
            title: 'Error',
            text: error.message || 'An error occurred while creating.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
        }
      }
    }
  },

  /** Watchers */
  watch: {
    createLoading(newVal) {
      if (newVal) {
        this.$vs.loading({
          container: '#create-member',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#create-member > .con-vs-loading')
      }
    }
  }
}
</script>
